import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-100">
      <SiteHeader />
      <main className="mx-auto flex w-full max-w-[1280px] flex-col items-center justify-center px-4 pb-20 pt-32 text-center md:px-8 md:pt-40">
        <p className="font-heading text-[80px] font-black leading-none text-primary-100 md:text-[140px]">404</p>
        <h1 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          这个页面走丢了
        </h1>
        <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-500">
          你访问的地址可能已经变更或不存在。返回首页继续浏览高清电视剧，或者去分类页按题材找剧。
        </p>
        <p className="mt-3 break-all rounded-md bg-background-200 px-3 py-1.5 text-xs text-foreground-500">
          {location.pathname}
        </p>
        <div className="mt-6 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-4-line" aria-hidden="true" />
            返回首页
          </Link>
          <Link
            to="/category"
            className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            浏览电视剧分类
          </Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}